export default __webpack_public_path__ + "static/media/vale-refeicao-nutricard.d9882e28.png";